import { useMemo } from 'react';
import SkeletonFavoriteCard from '../Skeleton';
import FavoriteItem from './Content';
import { ErrorCard, NoDataComponent } from '@starsoft/common/components';
import { usePlayerStatistics } from '@/api/players';

export default function FavoriteCardTable() {
  const { player, isPending, error, refetch } = usePlayerStatistics();

  const Games = useMemo(
    () =>
      player?.bettingFavorites?.map(betTracking => (
        <FavoriteItem
          bet={betTracking}
          key={`tracking-favorite-${betTracking?.id}`}
        />
      )),
    [player],
  );

  if (!player?.bettingFavorites || player?.bettingFavorites?.length == 0) {
    return <NoDataComponent />;
  }

  if (isPending) {
    return <SkeletonFavoriteCard />;
  }

  if (error) {
    return <ErrorCard error={error} refetch={refetch} />;
  }

  return Games;
}
